import { useEffect, useState } from "react";
import { Button, Grid, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import TextInput from "../../../../components/hookForms/textField";
import messages from "../../../../utils/messages";
import serviceClienteInstalacao from "../../../../services/serviceClienteInstalacao";

export interface IDialogProps {
  open: boolean;
  onSuccess: () => void;
  onClose: () => void;
  data: {
    open: boolean,
    id: string;
    numeroInstalacao: string;
    nomeCliente?: string;
  };
}

// 🔹 Schema vazio por enquanto (nenhum campo obrigatório)
const validationSchema = yup.object().shape({});

export default function DialogRestore({ open, onClose, data, onSuccess }: IDialogProps) {

  const [isDisable, setIsDisable] = useState(false);
  const {
    control,
    handleSubmit,
    reset,

  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      id: data.id,
      numeroInstalacao: data.numeroInstalacao,
      nomeCliente: data.nomeCliente,
    },
  });


  useEffect(() => {
    reset({
      id: data.id,
      numeroInstalacao: data.numeroInstalacao,
      nomeCliente: data.nomeCliente || "",
    });
  }, [data, reset]);

  const onSubmit = (values: any) => {
    setIsDisable(true);
    const updateValues = {
      ...values,
      historicoExlusaoID: data.id,
    }
    serviceClienteInstalacao
      .restore(updateValues)
      .then((result) => {
        if (result) {
          toast.success(messages.updateSucess);
          onClose();
          onSuccess();
        }
      })
      .catch((err) => {
        toast.error(messages.updateError, err);
      })
      .finally(() => {
        setIsDisable(false);
      });


  };

  return (
    <Dialog
      maxWidth="md"
      fullWidth
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          onClose();
        }
      }}
    >
      <DialogTitle>{"Restaurar Instalação"}</DialogTitle>

      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent style={{ padding: "30px 20px" }} dividers>
          <Grid container spacing={1}>

            <Grid item xs={12} md={12}>
              <TextInput
                name="numeroInstalacao"
                label="Instalação"
                control={control}
                disabled
              />
            </Grid>

            <Grid item xs={12} md={12}>
              <TextInput
                name="nomeCliente"
                label="Cliente"
                control={control}
                disabled
              />
            </Grid>
          </Grid>

          <DialogContentText sx={{ mt: 2 }}>
            <Typography variant="body1">
              Confirma a restauração deste registro?
            </Typography>

            <Typography variant="body1" color="textSecondary">
              Após a restauração, esta instalação voltará a ser incluída em todos os processos de faturamento.
            </Typography>
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ display: "flex", justifyContent: "center", m: 3 }}>
          <Button
            onClick={onClose}
            color="warning"
            variant="contained"
            sx={{ width: 159, height: 44 }}
          >
            Não
          </Button>

          <LoadingButton
            type="submit"
            color="primary"
            variant="contained"
            disabled={isDisable}
            sx={{ width: 159, height: 44 }}
          >
            Sim
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
}
